import React, { useState } from 'react';
import Sidebar from './components/Sidebar';
import TopBar from './components/TopBar';
import CanvasView from './components/CanvasView';
import GraphView from './components/GraphView';
import DemoView from './components/DemoView';
import CommandPalette from './components/CommandPalette';
import { initialNotes, connections, folders, tags } from './data/mockData';

function App() {
  const [notes, setNotes] = useState(initialNotes);
  const [activeView, setActiveView] = useState('demo'); // Default to Demo Hub as requested
  const [isCommandPaletteOpen, setCommandPaletteOpen] = useState(false);
  const [isPresentationMode, setIsPresentationMode] = useState(false);

  const updateNotePosition = (id, x, y) => {
    setNotes(notes.map(note => note.id === id ? { ...note, x, y } : note));
  };

  const handleAddNote = (newNote) => {
    setNotes([...notes, newNote]);
    if (activeView !== 'canvas') setActiveView('canvas');
  };

  const renderContent = () => {
    switch (activeView) {
      case 'canvas':
        return (
          <CanvasView 
            notes={notes} 
            connections={connections}
            updateNotePosition={updateNotePosition} 
            isPresentationMode={isPresentationMode}
          />
        );
      case 'graph':
        return <GraphView notes={notes} connections={connections} />;
      case 'demo':
        return <DemoView />;
      default:
        return <DemoView />;
    }
  };

  return (
    <div className="flex h-screen w-full bg-paper overflow-hidden font-sans text-ink selection:bg-maple-soft selection:text-maple">
      
      {/* Sidebar - Hidden in presentation mode */}
      {!isPresentationMode && (
        <Sidebar 
          folders={folders} 
          tags={tags} 
          activeView={activeView} 
          setActiveView={setActiveView} 
        />
      )}

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col relative overflow-hidden">
        <TopBar 
          toggleCommandPalette={() => setCommandPaletteOpen(true)} 
          togglePresentationMode={() => setIsPresentationMode(!isPresentationMode)}
          isPresentationMode={isPresentationMode}
          activeView={activeView}
        />
        
        <main className="flex-1 relative overflow-hidden">
          {renderContent()}

          {/* Quick Add Floating Button - Only show on functional views */}
          {(activeView === 'canvas' || activeView === 'graph') && (
            <button 
              onClick={() => setCommandPaletteOpen(true)}
              className="absolute bottom-6 right-1/2 translate-x-1/2 md:right-auto md:left-6 md:translate-x-0 w-14 h-14 bg-maple hover:bg-maple-light text-white rounded-full shadow-lg shadow-maple/30 flex items-center justify-center transition-transform hover:scale-105 active:scale-95 z-30"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" /></svg>
            </button>
          )}
        </main>
      </div>

      <CommandPalette 
        isOpen={isCommandPaletteOpen} 
        onClose={(overrideState) => {
          if (overrideState === true) setCommandPaletteOpen(true);
          else setCommandPaletteOpen(false);
        }}
        onAddNote={handleAddNote}
      />
    </div>
  );
}

export default App;